<template>
  <div>
    <table>
      <tbody>
        <tr>
          <translate tag="td"> Accommodation cost </translate>
          <td>
            <pu-price
              :price="quote.priceAccommodation"
              :display-original-price="true"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <compulsory-extras :extras="compulsoryExtras" />
    <extra-choices
      :extras="optionalExtras"
      :selected-extras="selectedExtras"
      @input="$emit('update:selected-extras', $event)"
    />

    <additional-taxes :taxes="quote.pricedTax" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { Quote } from '../quote/schema'
import { Extra, SelectedExtras } from '../schema'

@Component({
  emits: ['update:selected-extras'],
})
class BookingCosts extends Vue {
  @Prop()
  selectedExtras: SelectedExtras

  @Prop()
  quote: Quote

  get optionalExtras(): Extra[] {
    return this.quote.extras.filter((extra) => !extra.isCompulsory)
  }

  get compulsoryExtras(): Extra[] {
    return this.quote.extras.filter((extra) => extra.isCompulsory)
  }
}

export default toNative(BookingCosts)
</script>
<style scoped>
table {
  font-size: var(--body);
}

table tr td:last-of-type {
  text-align: right;
}
</style>
